export const ANIMATION_DURATION = 300; // ms

export const USER_ASSIGNMENT_STATUS = {
  ALL_ASSIGNED: 'ALL_ASSIGNED',
  NONE_ASSIGNED: 'NONE_ASSIGNED',
  PARTIALLY_ASSIGNED: 'PARTIALLY_ASSIGNED',
};
